import * as React from "react"
import { RouteComponentProps } from "react-router"
import CompanyInformation from "../../Administration/CompanyInformation";

export default class AddNewPortal extends React.PureComponent<RouteComponentProps> {
  render() {
    return <CompanyInformation {...this.props} portalMode isNew />
  }
}